
import EmailSignup from '@components/email-signup/EmailSignup';
import FooterContext from '@context/FooterContext';
import MenuContext from '@context/MenuContext';
import SvgGuesthouseLogoIcon from '@images/guesthouse-logo-icon';
import IconFacebook from '@mui/icons-material/Facebook';
import IconInstagram from '@mui/icons-material/Instagram';
import IconLinkedin from '@mui/icons-material/LinkedIn';
import IconPinterest from '@mui/icons-material/Pinterest';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import MuiLink from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import useBreakpoints from '@ui/hooks/useBreakpoints';
import Link from 'next/link';
import React, { useContext } from 'react';

import useStyles from './Footer.style';

const copyrightYear = new Date().getFullYear();

const Footer: React.FC = () => {
  const { classes, cx, theme } = useStyles();
  const { md } = useBreakpoints();
  const menuContext = useContext<MenuContext>(MenuContext);
  const footerContext = useContext<FooterContext>(FooterContext);

  const SERVICES = [
    {
      href: '/home-staging',
      text: 'Home Staging',
    },
    {
      href: '/cleaning',
      text: 'Cleaning'
    },
    {
      href: '/moving',
      text: 'Moving'
    },
    {
      href: '/photos',
      text: 'MLS Photography'
    },
    {
      href: '/photos',
      text: '3D Tours'
    }
  ];

  const NAV_1 = [
    {
      href: '/about',
      text: 'About Us',
    },
    {
      href: '/support',
      text: 'Support'
    },
    {
      href: '/referrals',
      text: 'Referral Program'
    },
    {
      href: '/affirm',
      text: 'Prep Now, Pay Later'
    },
    {
      href: '/press',
      text: 'Press',
    },
    {
      href: '/careers',
      text: 'Careers',
    },
  ];


  const NAV_2 = [
    {
      href: '/home-staging/denver',
      text: 'Denver',
    },
    {
      href: '/home-staging/boulder',
      text: 'Boulder',
    },
    {
      href: '/home-staging/san-diego',
      text: 'San Diego',
    },
    {
      href: '/home-staging/orange-county',
      text: 'Orange County'
    },
    {
      href: '/home-staging/phoenix',
      text: 'Phoenix'
    },
    {
      href: '/home-staging/scottsdale',
      text: 'Scottsdale'
    }
  ];

  const NAV_3 = [
    {
      href: '/terms-and-conditions',
      text: 'Terms & Conditions',
    },
    {
      href: '/privacy',
      text: 'Privacy',
    },
    {
      href: '/cookies',
      text: 'Cookies',
    },
    {
      href: '/sitemap.html',
      text: 'Sitemap',
    },
  ];

  if (!menuContext.showFooter) {
    return null;
  }

  return (
    <footer
      className={classes.footerWrapper}
      id="footer"
    >
      <div className={classes.footerContent}>
        <Box
          display="flex"
          flexDirection={md ? 'row' : 'column'}
          alignItems="flex-start"
          justifyContent="space-between"
          width="100%"
        >
          <Box
            style={{ marginBottom: theme.spacing(4) }}
          >
            <Link
              href="/"
              title="Guest House"
            >

              <SvgGuesthouseLogoIcon className={classes.footerIcon} />

            </Link>
          </Box>
        
          <Grid
            item
            xs={12}
            md={2}
            style={{ marginBottom: theme.spacing(4) }}
          >
            <Typography
              variant="h3Alt"
              style={{ marginBottom: theme.spacing(4), fontSize: '20px', color: '#B1B1B1' }}
            >
              Services
            </Typography>
            <ul className={classes.navigationList}>
              {SERVICES.map((item, i) => {
                return (
                  <li
                    key={i}
                    className={classes.navigationSecondaryItem}
                  >
                    <Link href={item.href}>

                      {item.text}

                    </Link>
                  </li>
                );
              })}
            </ul>
          </Grid>

          <Grid
            item
            xs={12}
            md={2}
            style={{ marginBottom: theme.spacing(4) }}
          >
            <Typography
              variant="h3Alt"
              style={{ marginBottom: theme.spacing(4), fontSize: '20px', color: '#B1B1B1' }}
            >
              Locations
            </Typography>
            <ul className={classes.navigationList}>
              {NAV_2.map((item, i) => {
                return (
                  <li
                    key={i}
                    className={classes.navigationSecondaryItem}
                  >
                    <Link href={item.href}>

                      {item.text}

                    </Link>
                  </li>
                );
              })}
            </ul>
          </Grid>

          <Grid
            item
            xs={12}
            md={2}
          >
            <Typography
              variant="h3Alt"
              style={{ marginBottom: theme.spacing(4), fontSize: '20px', color: '#B1B1B1' }}
            >
              Resources
            </Typography>
            <ul className={classes.navigationList}>
              {NAV_1.map((item, i) => {
                return (
                  <li
                    key={i}
                    className={classes.navigationSecondaryItem}
                  >
                    <Link href={item.href}>

                      {item.text}

                    </Link>
                  </li>
                );
              })}
            </ul>
          </Grid>

          <Grid
            item
            xs={12}
            md={3}
            className={classes.footerJoinCommunity}
          >
            <Box sx={{ marginBottom: theme.spacing(8) }}>
              <Typography
                gutterBottom
                component="h2"
                variant="h3Alt"
                style={{ marginBottom: theme.spacing(4), fontSize: '20px', color: '#B1B1B1' }}
              >
                Join our community
              </Typography>

              <EmailSignup
                campaignList="shoppers"
              />
            </Box>

            <Box>
              <Typography
                variant="h3Alt"
                style={{ marginBottom: theme.spacing(2), fontSize: '20px', color: '#B1B1B1' }}
              >
                Contact us
              </Typography>
              <MuiLink
                href={footerContext.phoneNumberHref}
                sx={{ fontSize: '18px', textDecoration: 'underline' }}
              >
                {footerContext.phoneNumberText}
              </MuiLink>
            </Box>

            <Grid
              container
              style={{ marginTop: theme.spacing(2) }}
            >
              <Grid
                item
                className={classes.footerSocial}
              >
                <a
                  href="https://www.pinterest.com/guesthouseshop/_created/"
                  rel="noopener noreferrer"
                  target="_blank"
                  aria-label="Guest House Pinterest"
                >
                  <IconPinterest className={classes.footerSocialIcon} />
                </a>
              </Grid>

              <Grid
                item
                className={classes.footerSocial}
              >
                <a
                  href="https://www.instagram.com/guesthouseshop/"
                  rel="noopener noreferrer"
                  target="_blank"
                  aria-label="Guest House Instagram"
                >
                  <IconInstagram className={classes.footerSocialIcon} />
                </a>
              </Grid>

              <Grid
                item
                className={classes.footerSocial}
              >
                <a
                  href="https://www.linkedin.com/company/guest-house-shop/about/"
                  rel="noopener noreferrer"
                  target="_blank"
                  aria-label="Guest House Linkedin"
                >
                  <IconLinkedin className={classes.footerSocialIcon} />
                </a>
              </Grid>

              <Grid
                item
                className={classes.footerSocial}
              >
                <a
                  href="https://www.facebook.com/guesthouseshop"
                  rel="noopener noreferrer"
                  target="_blank"
                  aria-label="Guest House Facebook"
                >
                  <IconFacebook className={classes.footerSocialIcon} />
                </a>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      

        <Grid
          container
          className={classes.footerLegal}
        >
          <Grid
            item
            xs={12}
            md={6}
            order={{ xs: 2, md: 1 }}
          >
            <span style={{ color: '#8a8e8e', lineHeight: '28px' }}>
              Copyright 
              {' '}
              {copyrightYear}
              {' '}
              - Guest House&copy;
            </span>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            order={{ xs: 3, md: 3 }}
          >
            <div className={classes.footerLegalListWrapper}>
              <ul className={cx(classes.navigationList, classes.footerLegalList)}>
                {NAV_3.map((item, i) => {
                  return (
                    <li
                      key={i}
                      className={classes.footerLegalItem}
                    >
                      <Link href={item.href}>

                        {item.text}

                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </Grid>
        </Grid>
      </div>
    </footer>
  );
};

export default Footer;
